/* eslint-disable @next/next/no-img-element */
//components
import { PillLink } from '@/containers-ai/Buttons';

//styles
import {
  HeroSection,
  HeroBg,
  HeroVisual,
  HeroOverlay,
  HeroInner,
  HeroKicker,
  HeroTitle,
  HeroDescription,
  HeroCta,
} from './Hero.styles';

export function Hero({ content }) {
  return (
    <HeroSection id="top">
      <HeroBg aria-hidden="true">
        <HeroVisual
          src="/images/contact/hero-lg.webp"
          srcSet="/images/contact/hero-sm.webp 700w, /images/contact/hero-md.webp 1400w, /images/contact/hero-lg.webp 2400w"
          sizes="100vw"
          fetchpriority="high"
          alt=""
        />
        <HeroOverlay />
      </HeroBg>
      <HeroInner>
        <HeroKicker>{content.kicker}</HeroKicker>
        <HeroTitle>{content.title}</HeroTitle>
        <HeroDescription>{content.description}</HeroDescription>
        <HeroCta>
          <PillLink href="#contact-form" className="qlf-btn-1">
            {content.ctaLabel}
          </PillLink>
        </HeroCta>
      </HeroInner>
    </HeroSection>
  );
}
